module.exports = __webpack_public_path__ + "img/MFT白皮书_19.cadbd5de.jpg";